import wglogo from '../assets/logo2.png' 
import profile from '../assets/profile.png'
import circle2 from '../assets/circle2.png'
import react from '../assets/react.png'
import flutter from '../assets/flutter.png'
import java from '../assets/java.png'
import bg from '../assets/bg.jpg'
import bg1 from '../assets/bg1.jpg'
import pic1 from '../assets/pic1.png'
import pic2 from '../assets/pic2.png'
import pic3 from '../assets/pic3.png'
import cir1 from '../assets/cir1.jpg'
import cir2 from '../assets/cir2.jpg'
import cir3 from '../assets/cir3.jpg'
import cir4 from '../assets/cir4.jpg'
import cir5 from '../assets/cir5.jpg'
import cir6 from '../assets/cir6.jpg'
import mobile from '../assets/mobile.png'
import email from '../assets/email.png'
 export default {
     wglogo,
     profile,
     circle2,
     react,
     flutter,
     java,
     bg,
     bg1,
     pic1,
     pic2,
     pic3,
     cir1,
     cir2,
     cir3,
     cir4,
     cir5,
     cir6,
     mobile,
     email
 }